<template>
  <form class="internal-transfer-page" :class="{ 'internal-transfer-page--dark': $vuetify.theme.dark }">
    <v-container fluid class="main-container responsive-height internal-transfer-container">
      <header class="internal-transfer-heading"><span><v-icon>mdi-swap-horizontal-bold</v-icon></span><div><h1>Internal Transfer</h1><p>Move funds securely between your trading accounts.</p></div></header>
      <v-row>
        <v-col xl="6" lg="6" md="5" sm="6" cols="12">
          <v-card class="deposit-form internal-transfer-form-card">
            <v-row>
              <v-col v-if="!internalTransferDetails?.otpsent" cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer From</legend>
                  <v-select ref="fromAccountSelected" solo :items="fromFormattedAccounts" item-value="id"
                    item-text="displayText" append-icon="mdi-chevron-down" label="Select From Account"
                    class="custom-select" hide-details="auto" @change="fromAccountSelected"></v-select>
                </fieldset>
                <span v-if="error.fromAccountError" class="error-message">
                  {{ error.fromAccountError }}
                </span>
              </v-col>
              <v-col v-if="!internalTransferDetails?.otpsent" cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer To</legend>
                  <v-select ref="toAccountSelected" solo :items="toFormattedAccounts" item-value="id"
                    item-text="displayText" append-icon="mdi-chevron-down" label="Select From Account"
                    class="custom-select" hide-details="auto" @change="toAccountSelected"></v-select>
                </fieldset>
                <span v-if="error.toAccountError" class="error-message">
                  {{ error.toAccountError }}
                </span>
              </v-col>
              <!-- <v-col
                v-if="!internalTransferDetails?.otpsent"
                cols="12"
                sm="12"
                md="12"
              >
                <fieldset>
                  <legend>Enter Amount (USD)</legend>
                  <v-text-field
                    type="number"
                    v-model="amount"
                    label="Enter Amount"
                    single-line
                    solo
                    hide-details="auto"
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
                <span v-if="error.amount_error" class="error-message">
                  {{ error.amount_error }}
                </span>
              </v-col> -->

              <v-col cols="12" sm="12" md="12" v-if="!internalTransferDetails?.otpsent">
                <fieldset>
                  <legend>Amount in (USD)</legend>
                  <v-text-field min="1" v-model="amount" label="$" type="number" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
                <span v-if="error.amount_error" class="error-message">
                  {{ error.amount_error }}
                </span>
              </v-col>

              <v-col cols="12" sm="12" md="12" v-if="this.currency.name !== 'USD' && !internalTransferDetails?.otpsent">
                <fieldset>
                  <legend>Amount in <span :style="{ color: currency.color }">({{ currency.name }})</span></legend>
                  <v-text-field readonly v-model="currencyAmount" :label="currency.symbol" type="number" single-line
                    solo hide-details class="custom-select text-muted"></v-text-field>
                </fieldset>
              </v-col>

              <v-col v-if="internalTransferDetails?.otpsent" cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Enter OTP Code</legend>
                  <v-text-field type="number" v-model="verifiedCode" @input="limitDigits" @keydown="onKeyDown"
                    label="Verify Code" single-line solo hide-details="auto" class="custom-select"></v-text-field>
                </fieldset>
                <span v-if="error.code_error" class="error-message">
                  {{ error.code_error }}
                </span>
              </v-col>

              <v-col v-if="internalTransferDetails?.otpsent" cols="12" sm="12" md="12">
                <v-btn @click.prevent="submitForm" :loading="loading2" :disabled="loading2" tile elevation="0"
                  class="ma-0 text-capitalize btn-account d-block w-100 internal-transfer-button">
                  Submit
                </v-btn>
              </v-col>
              <v-col v-if="!internalTransferDetails?.otpsent" cols="12" sm="12" md="12">
                <v-btn :loading="loading" :disabled="loading" @click.prevent="handleForm" tile elevation="0"
                  class="ma-0 text-capitalize btn-account d-block w-100 internal-transfer-button">
                  Send
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col xl="4" lg="4" md="7" sm="6" cols="12">
          <div class="card-wrapper-box mt-2">
            <v-card v-if="fromAccount" @click="fromDialog = true"
              class="elevation-0 deposit-form-card from-card transfer-account-card"
              :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
              <div class="ribbon"><span>From</span></div>
              <v-card-actions>
                <div class="trade-status">
                  <div>
                    <v-icon color="greenMain">mdi-signal</v-icon>
                  </div>
                  <div class="trade-number">
                    <span>MT5 - {{ this.fromAccount?.account_type_display }}</span>
                    <span>{{ this.fromAccount?.trading_account_no }}</span>
                  </div>
                </div>
              </v-card-actions>
              <v-card-actions>
                <div class="value-trades">
                  <span>Balance</span>
                  <span>{{ this.fromAccount?.Balance }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="value-trades">
                  <span>Currency</span>
                  <span>{{ this.fromAccount?.currency_name }}</span>
                </div>
              </v-card-actions>
              <v-card-actions>
                <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
                  <div>
                    <apexChart width="100%" height="95px" type="line" :options="options" :series="[
                      { name: 'Equity/Balance', data: seriesforFromAccount },
                    ]">
                    </apexChart>
                  </div>
                </v-sheet>
              </v-card-actions>
              <v-card-actions>
                <div class="currency-leverage">
                  <span>Equity</span>
                  <span>{{ this.fromAccount?.Equity }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="currency-leverage">
                  <span>Leverage</span>
                  <span>{{ this.fromAccount?.leverage }}:1</span>
                </div>
              </v-card-actions>
              <v-card-actions>
                <div class="balance-equity">
                  <span>Free Margin</span>
                  <span>{{ this.fromAccount?.MarginFree }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="balance-equity">
                  <span>Acc. Type</span>
                  <span>{{ this.fromAccount?.account_type_display }}</span>
                </div>
              </v-card-actions>
            </v-card>
            <v-dialog v-model="fromDialog" width="320">
              <v-card class="elevation-0 deposit-form-card from-card transfer-account-card"
                :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                <div class="ribbon"><span>From</span></div>
                <v-card-actions>
                  <div class="trade-status">
                    <div>
                      <v-icon color="greenMain">mdi-signal</v-icon>
                    </div>
                    <div class="trade-number">
                      <span>MT5 -
                        {{ this.fromAccount?.account_type_display }}</span>
                      <span>{{ this.fromAccount?.trading_account_no }}</span>
                    </div>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <div class="value-trades">
                    <span>Balance</span>
                    <span>{{ this.fromAccount?.Balance }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="value-trades">
                    <span>Currency</span>
                    <span>{{ this.fromAccount?.currency_name }}</span>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'
                    ">
                    <div>
                      <apexChart width="100%" height="95px" type="line" :options="options" :series="[
                        {
                          name: 'Equity/Balance',
                          data: seriesforFromAccount,
                        },
                      ]">
                      </apexChart>
                    </div>
                  </v-sheet>
                </v-card-actions>
                <v-card-actions>
                  <div class="currency-leverage">
                    <span>Equity</span>
                    <span>{{ this.fromAccount?.Equity }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="currency-leverage">
                    <span>Leverage</span>
                    <span>{{ this.fromAccount?.leverage }}:1</span>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <div class="balance-equity">
                    <span>Free Margin</span>
                    <span>{{ this.fromAccount?.MarginFree }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="balance-equity">
                    <span>Acc. Type</span>
                    <span>{{ this.fromAccount?.account_type_display }}</span>
                  </div>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card v-if="toAccount" @click="toDialog = true" class="elevation-0 deposit-form-card to-card transfer-account-card"
              :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
              <div class="ribbon"><span>To</span></div>
              <v-card-actions>
                <div class="trade-status">
                  <div>
                    <v-icon color="greenMain">mdi-signal</v-icon>
                  </div>
                  <div class="trade-number">
                    <span>MT5 - {{ this.toAccount?.account_type_display }}</span>
                    <span>{{ this.toAccount?.trading_account_no }}</span>
                  </div>
                </div>
              </v-card-actions>
              <v-card-actions>
                <div class="value-trades">
                  <span>Balance</span>
                  <span>{{ this.toAccount?.Balance }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="value-trades">
                  <span>Currency</span>
                  <span>{{ this.toAccount?.currency_name }}</span>
                </div>
              </v-card-actions>
              <v-card-actions>
                <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
                  <div>
                    <apexChart width="100%" height="95px" type="line" :options="options"
                      :series="[{ name: 'Equity/Balance', data: seriesData }]">
                    </apexChart>
                  </div>
                </v-sheet>
              </v-card-actions>
              <v-card-actions>
                <div class="currency-leverage">
                  <span>Equity</span>
                  <span>{{ this.toAccount?.Equity }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="currency-leverage">
                  <span>Leverage</span>
                  <span>{{ this.toAccount?.leverage }}:1</span>
                </div>
              </v-card-actions>
              <v-card-actions>
                <div class="balance-equity">
                  <span>Free Margin</span>
                  <span>{{ this.toAccount?.MarginFree }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="balance-equity">
                  <span>Acc. Type</span>
                  <span>{{ this.toAccount?.account_type_display }}</span>
                </div>
              </v-card-actions>
            </v-card>
            <v-dialog v-model="toDialog" width="320">
              <v-card class="elevation-0 deposit-form-card to-card transfer-account-card"
                :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                <div class="ribbon"><span>To</span></div>
                <v-card-actions>
                  <div class="trade-status">
                    <div>
                      <v-icon color="greenMain">mdi-signal</v-icon>
                    </div>
                    <div class="trade-number">
                      <span>MT5 - {{ this.toAccount?.account_type_display }}</span>
                      <span>{{ this.toAccount?.trading_account_no }}</span>
                    </div>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <div class="value-trades">
                    <span>Balance</span>
                    <span>{{ this.toAccount?.Balance }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="value-trades">
                    <span>Currency</span>
                    <span>{{ this.toAccount?.currency_name }}</span>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'
                    ">
                    <div>
                      <apexChart width="100%" height="95px" type="line" :options="options"
                        :series="[{ name: 'Equity/Balance', data: seriesData }]">
                      </apexChart>
                    </div>
                  </v-sheet>
                </v-card-actions>
                <v-card-actions>
                  <div class="currency-leverage">
                    <span>Equity</span>
                    <span>{{ this.toAccount?.Equity }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="currency-leverage">
                    <span>Leverage</span>
                    <span>{{ this.toAccount?.leverage }}:1</span>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <div class="balance-equity">
                    <span>Free Margin</span>
                    <span>{{ this.toAccount?.MarginFree }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="balance-equity">
                    <span>Acc. Type</span>
                    <span>{{ this.toAccount?.account_type_display }}</span>
                  </div>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRANSACTION__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      loading: false,
      loading2: false,
      fromDialog: false,
      toDialog: false,
      verifiedCode: null,
      fromClient_trading_account_id: null,
      toClient_trading_account_id: null,
      fromAccount: null,
      toAccount: null,
      amount: null,
      currencyAmount: '',
      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color:"#ffc400"
      },
      error: {
        fromAccountError: null,
        toAccountError: null,
        amount_error: null,
        code_error: null,
      },
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#ffc400"],
      },
    };
  },

  computed: {
    ...mapState("transactions", [
      "internaltransferAccount",
      "internalTransfer",
      "internalTransferDetails",
    ]),

    fromFormattedAccounts() {
      if (
        this.internaltransferAccount &&
        Array.isArray(this.internaltransferAccount)
      ) {
        const filteredAccounts = this.internaltransferAccount.filter(
          (item) => item.id !== this.toClient_trading_account_id
        );
        return filteredAccounts.map((account) => {
          const { id, trading_account_no, account_type_display, Balance } =
            account;
          const displayText = `${trading_account_no} (${account_type_display}) ${Balance} ${account.currency_name}`;
          return { id, displayText };
        });
      }
      return [];
    },

    toFormattedAccounts() {
      if (
        this.internaltransferAccount &&
        Array.isArray(this.internaltransferAccount)
      ) {
        const filteredAccounts = this.internaltransferAccount.filter(
          (item) => item.id !== this.fromClient_trading_account_id
        );
        return filteredAccounts.map((account) => {
          const { id, trading_account_no, account_type_display, Balance } =
            account;
          const displayText = `${trading_account_no} (${account_type_display}) ${Balance} ${account.currency_name}`;
          return { id, displayText };
        });
      }
      return [];
    },

    seriesData() {
      if (!this.toAccount) return [];

      const balance = Number(this.toAccount?.Balance) || 0;
      const equity = Number(this.toAccount?.Equity) || 0;

      if (balance > equity) {
        return [50, 20, 15, 10, -10, -15, -20];
      } else if (balance < equity) {
        return [-20, -15, -10, 10, 15, 20, 50];
      } else if (balance === equity) {
        return [45, 47, 43, 45, 43, 47, 45];
      } else {
        return [0, 0];
      }
    },

    seriesforFromAccount() {
      if (!this.fromAccount) return [];

      const balance = Number(this.fromAccount?.Balance) || 0;
      const equity = Number(this.fromAccount?.Equity) || 0;

      if (balance > equity) {
        return [50, 20, 15, 10, -10, -15, -20];
      } else if (balance < equity) {
        return [-20, -15, -10, 10, 15, 20, 50];
      } else if (balance === equity) {
        return [45, 47, 43, 45, 43, 47, 45];
      } else {
        return [0, 0];
      }
    },
  },

  watch: {
    amount(newAmount) {
      if (this.currency && this.currency.rate) {
        this.currencyAmount = (newAmount * this.currency.rate).toFixed(2);
      } else {
        this.currencyAmount = newAmount;
      }
    }
  },

  methods: {
    ...mapActions("transactions", [
      TRANSACTION__ACTIONS.INTERNALTRANSFERACCOUNT,
      TRANSACTION__ACTIONS.PAYMENTMETHOD,
      TRANSACTION__ACTIONS.INTERNALTRANSFERCODE,
      TRANSACTION__ACTIONS.CONFIRMINTERNALTRANSFER,
    ]),

    limitDigits() {
      if (this.verifiedCode.length > 6) {
        this.verifiedCode = this.verifiedCode.slice(0, 6);
      }
    },

    onKeyDown(event) {
      if (event.target.value.length >= 6 && event.keyCode !== 8) {
        event.preventDefault();
      }
    },

    fromAccountSelected(selectedAccount) {
      const filter = this.internaltransferAccount.find(
        (item) => item.id === selectedAccount
      );
      this.fromClient_trading_account_id = selectedAccount;
      this.fromAccount = filter;
    },

    toAccountSelected(selectedAccount) {
      const filter = this.internaltransferAccount.find(
        (item) => item.id === selectedAccount
      );
      this.toClient_trading_account_id = selectedAccount;
      this.toAccount = filter;
      if (filter) {
        this.currency.rate = filter.currency_rate;
        this.currency.name = filter.currency_name;
        this.currency.symbol = filter.currency_symbol;
        this.currency.color = filter.symbol_color;
      }
    },

    async handleForm() {
      this.loading = true;
      try {
        if (!this.fromAccount) {
          this.error.fromAccountError = "Select from account";
          return;
        } else {
          this.error.fromAccountError = null;
        }

        if (!this.toAccount) {
          this.error.toAccountError = "Select to account";
          return;
        } else {
          this.error.toAccountError = null;
        }

        if (this.toAccount.currency_name != this.fromAccount.currency_name) {
          this.error.toAccountError = "Select same currency type accounts";
          this.error.fromAccountError = "Select same currency type accounts";
          return;
        } else {
          this.error.toAccountError = null;
        }

         
        if (
          Number(this.amount) <
          Number(this.internalTransfer?.[0]?.min_transaction) ||
          Number(this.amount) > this.internalTransfer?.[0]?.max_transaction
        ) {
          this.error.amount_error = `Amount must be between ${this.internalTransfer?.[0]?.min_transaction} and ${this.internalTransfer?.[0]?.max_transaction}.`;
        } else if (Number(this.amount) > Number(this.fromAccount?.Balance)) {
          this.error.amount_error = `Insufficient balance`;
        } else {
          this.error.amount_error = null;
        }

        const data = {
          fromAccountID: this.fromAccount?.id,
          toAccountID: this.toAccount?.id,
          amount: Number(this.amount),
          client_account_id: this.fromAccount.client_account_id,
          trading_account_no: this.fromAccount.trading_account_no,
        };

        if (!Object.values(this.error).some((err) => err !== null)) {
          await this[TRANSACTION__ACTIONS.INTERNALTRANSFERCODE](data);
          // this.fromAccount = null;
          // this.toAccount = null;
          // this.amount = null;
        }
      } catch (error) {
        console.log(error);
      }finally {
        this.loading = false;
      }
    },

    async submitForm() {
      this.loading2 = true;
      try {
        if (!Object.values(this.error).some((err) => err !== null)) {
          await this[TRANSACTION__ACTIONS.CONFIRMINTERNALTRANSFER]({
            code: this.verifiedCode,
          });
          this.verifiedCode = null;
          this.fromAccount = null;
          this.toAccount = null;
          this.amount = null;
        }
      } catch (error) {
        console.log(error);
      }finally {
        this.loading2 = false;
      }
    },
  },
  async mounted() {
    await this[TRANSACTION__ACTIONS.INTERNALTRANSFERACCOUNT]();
    await this[TRANSACTION__ACTIONS.PAYMENTMETHOD]();
  },
};
</script>

<style scoped>
.internal-transfer-page {
  --it-page: #f7f8fa; --it-panel: #fff; --it-field: #fff; --it-border: #dfe2e6;
  --it-text: #171a1f; --it-muted: #626973; --it-gold: #d99a00;
  box-sizing: border-box; height: calc(100vh - 64px); min-height: 100%; overflow-x: hidden; overflow-y: auto;
  color: var(--it-text); background: var(--it-page); overscroll-behavior-y: contain; -webkit-overflow-scrolling: touch;
}
.internal-transfer-page--dark {
  --it-page: #030b13; --it-panel: #07111b; --it-field: #08131e; --it-border: #293026;
  --it-text: #f4f5f7; --it-muted: #aeb6c0; --it-gold: #ffc400;
  background: radial-gradient(circle at 70% 14%, rgba(255, 196, 0, .05), transparent 34%), var(--it-page);
}
.internal-transfer-container { box-sizing: border-box; max-width: none !important; min-height: 100%; padding: 16px 18px 24px !important; }
.internal-transfer-heading { min-height: 64px; display: flex; align-items: center; gap: 13px; margin-bottom: 8px; }
.internal-transfer-heading > span { width: 42px; height: 42px; display: inline-flex; align-items: center; justify-content: center; color: var(--it-gold); border: 1px solid rgba(217, 154, 0, .42); border-radius: 9px; background: rgba(217, 154, 0, .09); }
.internal-transfer-heading .v-icon { color: inherit; }
.internal-transfer-heading h1 { margin: 0 0 3px; color: var(--it-text); font-size: 23px; line-height: 1.2; }
.internal-transfer-heading p { margin: 0; color: var(--it-muted); font-size: 13px; }
.internal-transfer-form-card, .internal-transfer-page .transfer-account-card { color: var(--it-text) !important; border: 1px solid var(--it-border); border-radius: 10px !important; background: var(--it-panel) !important; box-shadow: none !important; }
.internal-transfer-form-card { padding: 12px 14px; }
/* Preserve existing inputs; replace only legacy colors. */
.internal-transfer-page .deposit-form fieldset { border-color: var(--it-border) !important; background: var(--it-field) !important; }
.internal-transfer-page .deposit-form fieldset legend { color: var(--it-text) !important; background: var(--it-panel) !important; }
.internal-transfer-page::v-deep .deposit-form fieldset .custom-select .v-input__slot { border-color: transparent !important; background: var(--it-field) !important; }
.internal-transfer-page::v-deep .deposit-form fieldset .custom-select input,
.internal-transfer-page::v-deep .deposit-form fieldset .custom-select .v-select__selection { color: var(--it-text) !important; }
.internal-transfer-page::v-deep .deposit-form fieldset .custom-select .v-label,
.internal-transfer-page::v-deep .deposit-form fieldset .custom-select input::placeholder { color: var(--it-muted) !important; opacity: .78; }
.internal-transfer-page::v-deep .deposit-form fieldset .custom-select .v-icon { color: var(--it-gold) !important; }
.internal-transfer-button { width: 100%; height: 44px !important; color: #17130a !important; border-radius: 6px !important; background: linear-gradient(135deg, #ffd43b, #ffc400) !important; font-weight: 700; }
.error-message { display: block; margin-top: 5px; color: #ff4c5f; font-size: 12px; }
.card-wrapper-box { display: grid; gap: 12px; }
.internal-transfer-page .transfer-account-card { overflow: hidden; }
.internal-transfer-page .transfer-account-card > .v-card__actions { min-height: 58px; padding: 12px 16px; border-bottom: 1px solid var(--it-border); }
.internal-transfer-page .transfer-account-card > .v-card__actions:last-child { border-bottom: 0; }
.internal-transfer-page .ribbon span { color: #17130a !important; background: #ffc400 !important; }
.internal-transfer-page .trade-status .v-icon { color: var(--it-gold) !important; }
.internal-transfer-page .trade-number span:first-child,
.internal-transfer-page .value-trades span:last-child,
.internal-transfer-page .currency-leverage span:last-child,
.internal-transfer-page .balance-equity span:last-child { color: var(--it-text); font-weight: 600; }
.internal-transfer-page .trade-number span:last-child,
.internal-transfer-page .value-trades span:first-child,
.internal-transfer-page .currency-leverage span:first-child,
.internal-transfer-page .balance-equity span:first-child { color: var(--it-muted); font-size: 11px; }
@media (max-width: 760px) {
  .internal-transfer-page { height: calc(100vh - 56px); height: calc(100dvh - 56px); }
  .internal-transfer-container { padding: 12px 10px 20px !important; }
  .internal-transfer-container > .row { margin-right: -6px; margin-left: -6px; }
  .internal-transfer-container > .row > [class*="col-"] { width: 100%; max-width: 100%; flex: 0 0 100%; padding: 6px; }
  .internal-transfer-heading p { display: none; }
  .internal-transfer-heading h1 { font-size: 21px; }
  .internal-transfer-form-card { padding: 7px; }
  .internal-transfer-form-card > .row { margin-right: -6px; margin-left: -6px; }
  .internal-transfer-form-card > .row > [class*="col-"] { padding: 6px; }
  .internal-transfer-button { width: 100%; }
}
</style>

<style>
.transfer-account-card.theme--light { color: #171a1f !important; border: 1px solid #dfe2e6; border-radius: 10px !important; background: #fff !important; }
.transfer-account-card.theme--dark { color: #f4f5f7 !important; border: 1px solid #5a470c; border-radius: 10px !important; background: #07111b !important; }
.transfer-account-card.theme--dark .v-icon { color: #ffc400 !important; }
.transfer-account-card .ribbon span { color: #17130a !important; background: #ffc400 !important; }
</style>
